// auto-generated - do not edit

export const MINIMUM_BROWSER_VERSIONS = {
  "chrome": 135,
  "edge": 135,
  "firefox": 137,
  "safari": 18
};
